import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ProductGroupService} from 'app/blocks/service/api/product-group.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IProductGroup} from 'app/blocks/model/product-group.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ProductGroup} from 'app/blocks/model/product-group.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class ProductGroupResource extends AbstractEntityResource<IProductGroup> {
    constructor(productGroupService: ProductGroupService, router: Router) {
        super(
            Resource.PRODUCT_GROUPS,
            productGroupService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_GROUPS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.PRODUCT_GROUPS),
            (entity?) => new ProductGroup(entity),
            (entity) => entity.name,
            'category'
        );
    }
}
